import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';

import { BaseComponents } from '../base.component';
import { Observable, of, throwError } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable()
export class SelfPaymentService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService
  ) {
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  public securityGroup:any = []

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if(this.VERIFY_TOKEN_EXPIRE){
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any) {
    const url = `${environment.endpointBackend}/api/selfPayment`;
    const body = this.input(param);
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  exec(param: any) {
      if(this.VERIFY_TOKEN_EXPIRE && this.wpTokenService.isTokenExpired()){
        return throwError(() => ({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus: 401,
          message: 'token is expired'
        }))
      }

      return this.connector(param).pipe(
        tap(res => {
          const token = res['headers']?.get('Authorization');
          if(token) {
            this.wpTokenService.storeToken(token);
          }
        }),
        switchMap(res => of(this.output(res['body'])))
      );
    }
}
